export default function Resource(
  urlTmp,
  url,
  name = "",
  isPremiumResource = false
) {
  return {
    urlTmp: urlTmp,
    url: url,
    name: name,
    isPremiumResource,
  };
}
